import { AccountCashflow } from '../type';

export const cpsHisIdKeyFn = (line: AccountCashflow) => `${line['CPS_HIS.ID']}`;
